const ArrayPreview = ({ value }) => {
  return JSON.stringify(value, null, 2);
};

export default ArrayPreview;
